<template>
  <div class="dashboard-container">
    <div
      v-if="loading"
      class="progress-bar"
      :style="{ width: progress + '%' }"
    ></div>

    <div class="mb-2 page-title">
      <i class="bi bi-file-earmark-text"></i> Tournament Arena List
    </div>

    <div class="mb-2 d-flex justify-content-end align-items-center">
      <router-link to="/admin/tournament-arena/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Add New
      </router-link>
    </div>

    <table class="table mt-4">
      <thead>
        <tr>
          <th>ID</th>
          <th>Tournament</th>
          <th>Arena Name</th>
          <th>Actions</th>
        </tr>
      </thead>

      <tbody v-if="tournamentArenas.length > 0">
        <tr
          v-for="(tournamentArena, index) in tournamentArenas"
          :key="tournamentArena.id"
        >
          <td>{{ index + 1 + (currentPage - 1) * perPage }}</td>
          <td>{{ tournamentArena.tournament?.name || '-' }}</td>
          <td>{{ tournamentArena.name }}</td>

          <td class="action-column">
            <div class="btn-group" role="group">
              <button
                type="button"
                class="button button-primary dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i class="bi bi-card-checklist"></i> Action
              </button>

              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-item"
                    href="#"
                    @click.prevent="EditArena(tournamentArena.id)"
                  >
                    <i class="bi bi-pencil-square"></i> Edit
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>
      </tbody>

      <tbody v-else>
        <tr>
          <td colspan="4" class="text-center">No arena found.</td>
        </tr>
      </tbody>
    </table>

    <nav v-if="totalPages > 1">
      <ul class="pagination pagination-lg justify-content-end">
        <li class="page-item" :class="{ disabled: !prevPageExists }">
          <button
            class="page-link"
            type="button"
            @click="changePage(currentPage - 1)"
            :disabled="!prevPageExists || loading"
          >
            <i class="bi bi-arrow-left-square"></i>
          </button>
        </li>

        <li
          v-for="page in totalPages"
          :key="page"
          class="page-item"
          :class="{ active: currentPage === page }"
        >
          <button
            class="page-link"
            type="button"
            @click="changePage(page)"
            :disabled="loading || currentPage === page"
          >
            {{ page }}
          </button>
        </li>

        <li class="page-item" :class="{ disabled: !nextPageExists }">
          <button
            class="page-link"
            type="button"
            @click="changePage(currentPage + 1)"
            :disabled="!nextPageExists || loading"
          >
            <i class="bi bi-arrow-right-square"></i>
          </button>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "TournamentArenaList",

  data() {
    return {
      tournamentArenas: [],
      searchQuery: "",
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      prevPageUrl: null,
      nextPageUrl: null,
      loading: false,
      progress: 0,
    };
  },

  mounted() {
    this.loadTournamentArenas();
  },

  methods: {
    async loadTournamentArenas(page = 1) {
      this.loading = true;
      this.progress = 30;

      try {
        const response = await axios.get("/tournament-arenas", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
          params: {
            page,
            perPage: this.perPage,
            search: this.searchQuery.trim(),
          },
        });

        const {
          current_page,
          last_page,
          data,
          next_page_url,
          prev_page_url,
        } = response.data;

        this.tournamentArenas = data || [];
        this.currentPage = current_page || page;
        this.totalPages = last_page || 1;
        this.nextPageUrl = next_page_url || null;
        this.prevPageUrl = prev_page_url || null;
        this.progress = 100;
      } catch (error) {
        console.error("Error loading tournament arenas:", error);

        this.tournamentArenas = [];
        this.currentPage = 1;
        this.totalPages = 0;
        this.nextPageUrl = null;
        this.prevPageUrl = null;
      } finally {
        setTimeout(() => {
          this.loading = false;
          this.progress = 0;
        }, 300);
      }
    },

    changePage(page) {
      if (this.loading) return;
      if (page < 1 || page > this.totalPages) return;
      if (page === this.currentPage) return;

      this.loadTournamentArenas(page);
    },

    searchClasses() {
      this.currentPage = 1;
      this.loadTournamentArenas(1);
    },

    async EditArena(id) {
      this.$router.push({ name: "EditArena", params: { id } });
    },

    deleteMenu(id) {
      console.log("Delete arena with ID:", id);
    },
  },

  computed: {
    prevPageExists() {
      return this.currentPage > 1;
    },

    nextPageExists() {
      return this.currentPage < this.totalPages;
    },
  },
};
</script>

<style scoped>
.dashboard-container {
  background-color: #ffffff;
  margin-top: 80px;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
}

.table th,
.table td {
  padding: 10px;
}

.navbar {
  background-color: #1E2A57 !important;
}

.navbar-toggler-icon {
  background-color: white;
}

.nav-link {
  color: white !important;
}

.form-control {
  width: 250px;
}

.progress-bar {
  position: absolute;
  top: 0;
  left: 0;
  height: 5px;
  background-color: #388E3C;
  animation: loader-animation 1.5s infinite;
}

@keyframes loader-animation {
  0% {
    width: 0;
    background-color: #388E3C;
  }

  50% {
    width: 50%;
    background-color: #388E3C;
  }

  100% {
    width: 100%;
    background-color: #388E3C;
  }
}
</style>